module.exports = __webpack_public_path__ + "static/img/1.f96ab49.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/ad/1.jpg
// module id = AMFW
// module chunks = 1